import * as React from "react";
import { forwardRef } from "react";
const SvgSquare = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "currentColor", viewBox: "0 0 24 24", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M5.275 21.407c-.63 0-1.166-.222-1.61-.666A2.193 2.193 0 0 1 3 19.131V5.275c0-.63.222-1.166.665-1.61.444-.443.98-.665 1.61-.665h13.856c.63 0 1.167.222 1.61.665.444.444.666.98.666 1.61v13.856a2.19 2.19 0 0 1-.666 1.61 2.19 2.19 0 0 1-1.61.666H5.275Zm0-2.276h13.856V5.275H5.275v13.856Z" }));
const ForwardRef = forwardRef(SvgSquare);
export default ForwardRef;
